import * as Yup from 'yup';

export const competenceSchema = Yup.object().shape({
  competences: Yup.array().max(5),
});
